import SearchPaginationLinkButton from './SearchPaginationLinkButton';

export default SearchPaginationLinkButton;
